export const ogText: string[] = [
  `"Fury said to`,
  `a mouse, That`,
  `he met`,
  `in the`,
  `house,`,
  `'Let us`,
  `both go`,
  `to law:`,
  `I will`,
  `prosecute`,
  `you.—`,
  `Come, I'll`,
  `take no`,
  `denial;`,
  `We must`,
  `have a`,
  `trial:`,
  `For`,
  `really`,
  `this`,
  `morning`,
  `I've`,
  `nothing`,
  `to do.'`,
  `Said the`,
  `mouse to`,
  `the cur,`,
  `'Such a`,
  `trial,`,
  `dear sir,`,
  `With no`,
  `jury or`,
  `judge,`,
  `would be`,
  `wasting`,
  `our breath.'`,
  `'I'll be`,
  `judge,`,
  `I'll be`,
  `jury,'`,
  `Said`,
  `cunning`,
  `old Fury;`,
  `'I'll try`,
  `the whole`,
  `cause,`,
  `and`,
  `condemn`,
  `you`,
  `to`,
  `death.'"`,
];

export const myText: string[] = [
  `An analysis`,
  `of the text of`,
  `"Alice's`,
  `Advent-`,
  `-ures in`,
  `Wonderland"`,
  `by Lewis`,
  `Carroll,`,
  `using`,
  `Python 3,`,
  `NumPy, Pandas,`,
  `Matplotlib,`,
  `and NLTK`,
  `(or the`,
  `Natural`,
  `Language`,
  `Toolkit).`,
  `This`,
  `analysis`,
  `includes`,
  `data such as`,
  `VADER`,
  `Sentiment`,
  `analyses,`,
  `average`,
  `sentence`,
  `lengths`,
  `per chapter,`,
  `chunking`,
  `to extract`,
  `unique`,
  `named entities`,
  `from the text,`,
  `and various`,
  `figures to`,
  `visualize`,
  `the data.`,
  `I made`,
  `this`,
  `project`,
  `to practice`,
  `data analysis,`,
  `visualization,`,
  `and natural`,
  `language`,
  `processing.`,
  `I hope`,
  `you`,
  `like it!`,
  `-Terry`,
  `Zhou`,
];